import type { ThemeColors } from '../../../../tokens/colors/types';
import type { BaseDeprecatedColors } from '../../../types';
import derivedED from './ED';

export default (baseColors: ThemeColors): BaseDeprecatedColors => {
  return derivedED(baseColors);
};
